export default function isTypedArrayMember<T>(value: unknown, array: readonly T[]): value is T {
  // We're relying on runtime validation here
  // eslint-disable-next-line local/no-new-type-assertions
  return array.includes(value as T)
}

/**
 * The problem we're trying to solve:
 * const x: UserAuthRole[] = []
 * const value1 = ((): string => 'user:basic')()
 *
 * x.push(value1)
 * ^ Error: Argument of type 'string' is not assignable to parameter of type 'UserAuthRole'
 *
 * How to fix:
 * const y: UserAuthRole[] = []
 * const value2 = ((): UserAuthRole => 'user:basic')()
 *
 * if (isTypedArrayMember(value2, USER_AUTH_ROLES)) {
 *   y.push(value2)
 * }
 * ^ No error
 */
